<template>
    <div class="filter-result">
        <span v-if="listLength === 0" class="filter-result__no-results" v-html="$t('TotemFilterResult.no_results')"></span>
        <span v-if="listLength > 0" class="filter-result__total" v-html="">{{ listLength }} <span v-html="$t('TotemFilterResult.total')"></span> </span>
    </div>
</template>

<script>
    export default {
        name: 'totem-filter-result',
        props: {
            listLength: Number
        }
    }
</script>

<style lang="scss" scoped>
    .filter-result {
        display: flex;
        flex-direction: row;
        align-items: center;

        [class*="desktop"] & {
            margin: 0;
            align-items: flex-start;
        }

        [class*="mobile"] & {
            margin: 0 5px 0 0;
        }

        &__title {
            font-size: 2.3rem;
        }

        &__total {
            margin: 0 20px 0 0;
        }

        &__total,
        &__no-results {
            font-family: PPAgrandir-Medium, sans-serif;
            font-size: 2.4rem;
        }
    }
</style>
